/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type StockHistoryDetailsQueryVariables = {|
  stockId?: ?string
|};
export type StockHistoryDetailsQueryResponse = {|
  +stockHistoryDetails: ?any
|};
export type StockHistoryDetailsQuery = {|
  variables: StockHistoryDetailsQueryVariables,
  response: StockHistoryDetailsQueryResponse,
|};
*/


/*
query StockHistoryDetailsQuery(
  $stockId: ID
) {
  stockHistoryDetails(stockId: $stockId)
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "stockId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "stockId",
        "variableName": "stockId"
      }
    ],
    "kind": "ScalarField",
    "name": "stockHistoryDetails",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StockHistoryDetailsQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StockHistoryDetailsQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "4e98439acc0d432fe1746c6594b1c36c",
    "id": null,
    "metadata": {},
    "name": "StockHistoryDetailsQuery",
    "operationKind": "query",
    "text": "query StockHistoryDetailsQuery(\n  $stockId: ID\n) {\n  stockHistoryDetails(stockId: $stockId)\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b22be97b23a4f30f957e9f40743cd0fa';

module.exports = node;
